import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorFallbackProps {
  resetError: () => void;
}

export function ErrorFallback({ resetError }: ErrorFallbackProps) {
  return (
    <div
      className="flex min-h-[100dvh] items-center justify-center bg-background p-6"
      role="alert"
      data-testid="error-fallback"
    >
      <div className="max-w-md w-full text-center space-y-4">
        <div className="mx-auto h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center">
          <AlertTriangle className="h-6 w-6 text-destructive" />
        </div>
        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-foreground">
            Something went wrong
          </h1>
          <p className="text-sm text-muted-foreground">
            An unexpected error occurred and the page couldn't load. The issue
            has been reported automatically. You can try again, or reload the
            page if it keeps failing.
          </p>
        </div>
        <div className="flex items-center justify-center gap-2">
          <Button
            onClick={() => {
              resetError();
            }}
            variant="default"
          >
            <RefreshCw className="h-4 w-4" />
            Try again
          </Button>
          <Button
            onClick={() => {
              window.location.reload();
            }}
            variant="outline"
          >
            Reload page
          </Button>
        </div>
      </div>
    </div>
  );
}
